module.exports = "https://cb-static.prod-my.games/promo/twitchregionselect/img/twitch-logo.909f152f.svg";